// extracted by mini-css-extract-plugin
export default {"ActivityLogsPage":"ActivityLogsPage_ActivityLogsPage__Bd86o"};